import { inject } from 'vue'
import { toastBridge } from '@/services/toastBridge'

/**
 * Toast composable for Vue components
 * 
 * This composable provides access to the toast system within Vue components.
 * It will use the injected toast API if available (when inside ToastProvider),
 * or fall back to the toastBridge for edge cases.
 * 
 * @returns {Object} Toast API methods
 */
export function useToast() {
  // Try to inject the toast API from ToastProvider
  const toast = inject('toast', null)

  // If we have the injected toast API, use it
  if (toast) {
    return toast
  }

  // Fallback to toastBridge (useful during testing or if used outside ToastProvider)
  console.warn('useToast: Toast provider not found, falling back to toastBridge')
  
  return {
    show: (message, options) => toastBridge.show(message, options),
    success: (message, options) => toastBridge.success(message, options),
    error: (message, options) => toastBridge.error(message, options),
    warning: (message, options) => toastBridge.warning(message, options),
    info: (message, options) => toastBridge.info(message, options),
    primary: (message, options) => toastBridge.primary(message, options),
    persistent: (message, type) => toastBridge.persistent(message, type),
    dismiss: (id) => toastBridge.dismiss(id),
    clearAll: () => toastBridge.clearAll()
  }
}